import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Blogs.module.scss";
import backPagination from "../../assets/images/backPagination.png";
import nextPagination from "../../assets/images/nextPagination.png";
import RethinkingVocationalEducation16 from "../../assets/images/learning-formats-redefining-indias-future-of-skilling.jpeg";
import RethinkingVocationalEducation27 from "../../assets/images/corporate-training-and-retention-why-skill-development-programs-matter-for-employers.jpeg";
import RethinkingVocationalEducation28 from "../../assets/images/vocational-training-courses-for-media-and-entertainment-beauty-and-wellness-and-3d-printing.jpeg";
import RethinkingVocationalEducation29 from "../../assets/images/how-to-create-a-career-from-scratch-in-2025-a-step-by-step-guide.jpeg";

import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { FiX } from "react-icons/fi";
import { Icon } from "../../assets/Icons.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import classNames from "classnames";
import { motion } from "framer-motion";
import MetaComponent from "../CommonComponents/MetaComponent.tsx";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const timeout = 3000;

const Blogs: React.FC = () => {
  // Please add the latest blog on first place
  const blogsData = [
    {
      main_img: "/images/blog/flexible-vocational-training-design-classroom.jpg",
      imgAlt: "Students collaborating on digital design project during vocational training session",
      imgTitle: "Flexible Vocational Training Programs | Aptech Limited",
      title: "Flexible Vocational Training Options That Can Land You a Job",
      date: "2026-02-24",
    },
    {
      main_img: "/images/blog/digital-skills-vocational-training-classroom.jpg",
      imgAlt: "Instructor guiding student on laptop with data analytics dashboard in classroom",
      imgTitle: "Digital Skills in Vocational Education | Aptech Limited",
      title: "Digital Skills in Vocational Education That Employers Want",
      date: "2026-02-17",
    },
    {
      main_img: "/images/blog/empowering-youth-through-skill-training.jpeg",
      imgAlt: "Empowering Youth Through Skill Training",
      imgTitle: "Empowering Youth Through Skill Training",
      title: "Empowering Youth Through Skill Training",
      date: "2026-02-10",
    },
    {
      main_img:
        "/images/blog/emerging-domain-career-opportunities.jpg",
      imgAlt: "Young professionals showcasing skills in technology, design, and corporate roles",
      imgTitle: "Career Opportunities in Emerging Domains | Aptech Limited",
      title: "Career Opportunities in Emerging Domains",
      date: "2026-02-03",
    },
    {
      main_img:
        "/images/blog/campus-to-corporate-training-transition.jpg",
      imgAlt: "Student in classroom transitioning to corporate professional working on laptop",
      imgTitle: "Campus to Corporate Training Programs | Aptech Limited",
      title: "Campus-to-Corporate Transformative Impact of Institutional Training Programs",
      date: "2026-01-27",
    },
    {
      main_img:
        "/images/blog/future-careers-you-can-pursue-with-vocational-training-courses.jpg",
      imgAlt: "Students learning coding on laptops",
      imgTitle: "Technology training classroom",
      title: "Future Careers You Can Pursue with Vocational Training Courses",
      date: "2026-01-20",
    },
    {
      main_img:
        "/images/blog/acquire-in-demand-skills-fast.jpg",
      imgAlt: "Instructor guiding students on computers",
      imgTitle: "Hands-on vocational training",
      title: "Acquire In-Demand Skills Fast: Advantages of Short-Term Training Programs",
      date: "2026-01-13",
    },
    {
      main_img:
        "/images/blog/vocational-training-courses-for-media-and-entertainment.jpg",
      imgAlt: "Students discussing vocational training projects during a practical learning session",
      imgTitle: "Students discussing vocational training projects during a practical learning session",
      title: "Vocational Training Courses for Media and Entertainment, Beauty and Wellness, and 3D Printing",
      date: "2026-01-06",
    },
    {
      main_img:
      "/images/blog/how-hybrid-learning-readies-students-for-global-careers.jpg",
      imgAlt: "Students studying together outdoors",
      imgTitle: "Collaborative outdoor learning",
      title: "How Hybrid Learning readies students for global careers",
      date: "2025-12-30",
    },
    {
      main_img: "/images/blog/how-to-create-a-career-from-scratch-in-2025-a-step-by-step-guide.jpg",
      imgAlt: "Students discussing ideas in a classroom",
      imgTitle: "Classroom group discussion",
      title:
        "How to Create a Career from Scratch in 2025: A Step-by-Step Guide",
      date: "2025-12-23",
    },
    {
      main_img: "/images/blog/vocational-training-courses-for-media-and-entertainment-beauty-and-wellness-and-3d-printing.jpg",
      imgAlt: "Students discussing vocational training projects during a practical learning session",
      imgTitle: "Vocational training courses at Aptech Limited",
      title:
        "Bridging Learning and Employment",
      date: "2025-12-09",
    },
    {
      main_img: "/images/blog/corporate-training-and-retention-why-skill-development-programs-matter-for-employers.jpg",
      imgAlt:
        "Employees participating in a corporate training discussion led by an instructor",
      imgTitle:
        "Corporate training programs at Aptech Limited",
      title:
        "Corporate Training and Retention: Why Skill Development Programs Matter for Employers",
      date: "2025-12-02",
    },
    {
      main_img: "/images/blog/skill-development-trends-india-insights.jpg",
      imgAlt:
        "Group of students collaborating on digital skill development projects in a classroom",
      imgTitle:
        "Skill development trends in India and what they mean for you | Aptech Limited",
      title: "Skill Development Trends in India and What That Means for You",
      date: "2025-11-25",
    },
    {
      main_img: "/images/blog/top-10-in-demand-vocational-careers-2025.jpg",
      imgAlt: "Mentor supervising student using design tools on an iMac",
      imgTitle:
        "High-demand vocational careers with practical training | Aptech Limited",
      title: "Top 10 Vocational Careers in Demand 2025",
      date: "2025-11-18",
    },
    {
      main_img:
        "/images/blog/short-term-vocational-courses-reliable-careers.jpg",
      imgAlt:
        "Students discussing a design project in a classroom with character models on screen",
      imgTitle:
        "Short-term vocational courses that lead to reliable careers | Aptech Limited",
      title: "Short-Term Vocational Courses That Lead to Reliable Careers",
      date: "2025-11-11",
    },
    {
      main_img: "/images/blog/vocational-training-future-skill-development.jpg",
      imgAlt: "Group of students talking and smiling in a campus corridor",
      imgTitle:
        "Vocational education shaping the future of skill development in India | Aptech Limited",
      title: "Why Vocational Training Is the Future of Skill Development",
      date: "2025-11-04",
    },
    {
      main_img: "/images/blog/vocational-ai-learning-benefits-students.jpeg",
      imgAlt:
        "Student learning with humanoid robot using AI tools in a modern classroom",
      imgTitle:
        "Benefits of vocational and AI-powered learning for students in 2025 | Aptech Limited",
      title:
        "Benefits of Vocational and AI-Powered Learning for Students in 2025",
      date: "2025-10-28",
    },
    {
      main_img:
        "/images/blog/how-vocational-skills-help-in-having-sustainable-careers.jpg",
      imgAlt:
        "Two students studying together with a laptop and tablet in a cafe.",
      imgTitle: "The Role of Vocational Skills in Building Sustainable Careers",
      title: "How Vocational Skills Help in Having Sustainable Careers",
      date: "2025-10-14",
    },
    {
      main_img:
        "/images/blog/why-employers-value-vocationally-trained-professionals.jpg",
      imgAlt:
        "College students collaborating on a project in a modern study room.",
      imgTitle: "Why Companies Prefer Vocationally Skilled Employees",
      title: "Why Employers Value Vocationally Trained Professionals",
      date: "2025-10-07",
    },
    {
      main_img: "/images/blog/ai-education-student-working-with-robot.jpg",
      imgAlt: "Man collaborating with an AI robot at a computer desk",
      imgTitle: "Future-Ready Education with AI Support",
      title: "Why AI & Education are More Crucial Than Ever",
      date: "2025-09-30",
    },
    {
      main_img: "/images/blog/group-of-students-and-professor-in-classroom.jpg",
      imgAlt: "Group discussion between students and teacher",
      imgTitle: "Technology-Driven Classroom Discussions",
      title:
        "How Institutional Partnerships Are Driving the Future of Skill Development",
      date: "2025-09-23",
    },
    {
      main_img: "/images/blog/group-study-and-learning-environment.jpg",
      imgAlt: "Smiling college students collaborating on project",
      imgTitle: "Student Collaboration and Creativity",
      title:
        "Top Advantages of Skilling Programs for Institutions and Businesses",
      date: "2025-09-16",
    },
    {
      main_img: RethinkingVocationalEducation16,
      title: "Learning Formats Redefining India's Future of Skilling",
      date: "2025-09-09",
    },
    {
      main_img: "/images/blog/man-learning-with-humanoid-robot.jpg",
      imgAlt: "Man exploring innovation with AI assistant",
      imgTitle: "Empowering Learning Through AI",
      title: "How AI and Data are Revolutionising Employee Learning",
      date: "2025-09-02",
    },
    {
      main_img: "/images/blog/friends-studying-in-cafe.jpg",
      imgAlt: "Two young professionals learning online",
      imgTitle: "Digital Learning and Teamwork in Education",
      title:
        "Bridging the Skills Gap in India: Challengesand solutions for the 2025 workforce",
      date: "2025-08-26",
    },
    {
      main_img: "/images/blog/students-listening-to-mentor.jpg",
      imgAlt: "Instructor guiding students during training session",
      imgTitle: "Professional Training for Young Learners",
      title: "Vocational Training as a Pathway to Self-Reliance",
      date: "2025-08-19",
    },
    {
      main_img: "/images/blog/woman-practicing-coding-on-laptop.jpg",
      imgAlt: "Woman wearing headphones learning coding online",
      imgTitle: "Woman Developing Coding Skills",
      title:
        "Blending Technology with Skilling & Vocational Training Through Hybrid Learning Formats",
      date: "2025-08-12",
    },
    {
      main_img: "/images/blog/man-and-woman-talking-in-office.jpg",
      imgAlt: "Two professionals discussing work in a modern office",
      imgTitle: "Productive Office Conversation",
      title:
        "Turning Passion & Purpose into Profit: How Aptech Is Helping Students become entrepreneurs / solopreneurs",
      date: "2025-08-05",
    },
    {
      main_img: "/images/blog/learning-and-collaboration-among-students.jpg",
      imgAlt: "Group of students studying and discussing together",
      imgTitle: "Collaborative Learning Among Students",
      title:
        "Beyond the Classroom: Why India Needs Experiential Learning in Today's Skilling Ecosystem",
      date: "2025-07-29",
    },
    {
      main_img: "/images/blog/group-of-women-learning-new-skills.jpg",
      imgAlt: "Students receiving mentorship in an academic setting",
      imgTitle: "Mentorship and Collaborative Learning",
      title: "What Today's Employers Want, And How Skilling Course Delivers",
      date: "2025-07-22",
    },
    {
      main_img: "/images/blog/careers-that-match-the-market-demand.jpg",
      imgAlt:
        "Young professional working on digital content creation at a modern workspace",
      imgTitle: "In-Demand Skills for Future Career Success",
      title:
        "Careers That Match The Market Demand: Training For High-Growth Sectors",
      date: "2025-07-15",
    },
    {
      main_img:
        "/images/blog/bridging-skill-gaps-globally-through-structured-training-programs.jpg",
      imgAlt:
        "Design workshop in session with a teacher projecting a digital painting tutorial for the class.",
      imgTitle:
        "bridging-skill-gaps-globally-through-structured-training-programs",
      title:
        "Bridging Skill Gaps Globally Through Structured Training Programs",
      date: "2025-07-08",
    },
    {
      main_img:
        "/images/blog/why-investing-in-a-vocational-training-franchise-makes-sense.jpg",
      imgAlt: "Two business professionals shaking hands over a table",
      imgTitle: "Benefits of Investing in a Vocational Training Franchise",
      title: "Why Investing in A Vocational Training Franchise Makes Sense",
      date: "2025-07-01",
    },
    {
      main_img: "/images/blog/skills-are-the-currency-of-the-future.jpg",
      imgAlt:
        "Diverse team of three young professionals smiling and giving thumbs up in a modern office.",
      imgTitle: "Importance of Skills for Future Career Growth",
      title: "Skills are the currency of the future",
      date: "2025-06-24",
    },
    {
      main_img:
        "/images/blog/how-vocational-training-is-changing-career-paths-in-india.jpg",
      imgAlt:
        "Team of four animation students collaborating on a character rigging project displayed on a desktop monitor.",
      imgTitle:
        "Vocational Training Transforming Career Opportunities in India",
      title: "How Vocational Training is Changing Career Paths in India",
      date: "2025-06-17",
    },
    {
      main_img:
        "/images/blog/the-importance-of-vocational-training-in-india-for-students.jpg",
      imgAlt:
        "Student and male business professional shaking hands in a modern office",
      imgTitle: "How Vocational Training Prepares Students for the Future",
      title: "The Importance of Vocational Training in India for Students",
      date: "2025-06-09",
    },
    {
      main_img:
        "/images/blog/indias-top-vocational-skill-development-provider-institutes.jpg",
      imgAlt:
        "Young man leading a support group meeting counseling discussion in a circle.",
      imgTitle: "Leading Vocational Skill Development Institutes in India",
      title: "India’s Top Vocational Skill Development Provider Institutes",
      date: "2025-06-02",
    },
    {
      main_img:
        "/images/blog/rethinking-vocational-education-training-for-tomorrow.jpg",
      imgAlt:
        "Smiling man with a laptop in a busy modern office with colleagues in the background.",
      imgTitle:
        "Modern Approaches to Vocational Training for Tomorrow’s Careers",
      title: "Rethinking Vocational Education: Training for Tomorrow",
      date: "2025-05-27",
    },
  ];
  const navigate = useNavigate();
  const [apiBlogs, setApiBlogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState("");

  /* ---------------- FETCH API BLOGS ---------------- */
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const requestBody = {
          brand_id: 1
        };
        const res = await axios.post(`${API_BASE_URL}/blog/lists`, requestBody, { timeout },);

        // normalize API blogs
        const formatted = res.data.blogs.map((blog: any) => ({
          main_img: blog.banner_image,
          imgAlt: blog.alt_text,
          imgTitle: blog.blog_name,
          title: blog.blog_name,
          date: new Date(blog.createdAt),
          slug: blog.blog_slug,
          source: "api",
        }));

        setApiBlogs(formatted);
      } catch (error) {
        console.error("Blog API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  /* ---------------- MERGE STATIC + API ---------------- */
  console.log("apiBlogs", apiBlogs)
  const mergedBlogs = [...apiBlogs, ...blogsData]
    .filter(
      (blog, index, self) =>
        index === self.findIndex((b) => b.title === blog.title)
    ) // avoid duplicate titles
    .sort(
      (a, b) =>
        new Date(b.date).getTime() - new Date(a.date).getTime()
    );

  /* ---------------- SEARCH ---------------- */
  const filteredBlogs = mergedBlogs.filter((blog) =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const itemsPerPage = 9;
  const totalPages = Math.ceil(filteredBlogs.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredBlogs.slice(startIndex, endIndex);

  /* ---------------- NAVIGATION ---------------- */
  const handleCardClick = (blog: any) => {
    if (blog.slug) {
      navigate(`/our-blogs/${blog.slug}`);
    } else {
      console.log("blogs:", blog)
      const slug = blog
      .toLowerCase()
      .replace(/[:]/g, "")
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, ""); // make it URL friendly

      // previous code
      //.replace(/\s+/g, "-");
      console.log(slug, "Rakesh");
      navigate(`/our-blogs/${slug}`);
    }
  };
  // const filteredBlogs = blogsData.filter((blog) =>
  //   blog.title.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const createPagination = () => {
    let str: JSX.Element[] = [];
    let pageCutLow = currentPage - 1;
    let pageCutHigh = currentPage + 1;

    if (currentPage > 1) {
      str.push(
        <li key="prev" className={`${styles.pageItem} ${styles.previous}`}>
          <a onClick={() => setCurrentPage(currentPage - 1)}>
            <img src={backPagination} alt="backPagination" />
          </a>
        </li>
      );
    }

    if (totalPages < 6) {
      for (let p = 1; p <= totalPages; p++) {
        str.push(
          <li
            key={p}
            className={`${styles.pageItem} ${
              currentPage === p ? styles.active : ""
            }`}
          >
            <a onClick={() => setCurrentPage(p)}>{p}</a>
          </li>
        );
      }
    } else {
      if (currentPage > 2) {
        str.push(
          <li key="first" className={styles.pageItem}>
            <a onClick={() => setCurrentPage(1)}>1</a>
          </li>
        );
        if (currentPage > 3) {
          str.push(
            <li key="dots-prev" className={styles.outOfRange}>
              <a onClick={() => setCurrentPage(currentPage - 2)}>...</a>
            </li>
          );
        }
      }

      if (currentPage === 1) {
        pageCutHigh += 2;
      } else if (currentPage === 2) {
        pageCutHigh += 1;
      }
      if (currentPage === totalPages) {
        pageCutLow -= 2;
      } else if (currentPage === totalPages - 1) {
        pageCutLow -= 1;
      }

      for (let p = pageCutLow; p <= pageCutHigh; p++) {
        if (p > 0 && p <= totalPages) {
          str.push(
            <li
              key={p}
              className={`${styles.pageItem} ${
                currentPage === p ? styles.active : ""
              }`}
            >
              <a onClick={() => setCurrentPage(p)}>{p}</a>
            </li>
          );
        }
      }

      if (currentPage < totalPages - 1) {
        if (currentPage < totalPages - 2) {
          str.push(
            <li key="dots-next" className={styles.outOfRange}>
              <a onClick={() => setCurrentPage(currentPage + 2)}>...</a>
            </li>
          );
        }
        str.push(
          <li key="last" className={styles.pageItem}>
            <a onClick={() => setCurrentPage(totalPages)}>{totalPages}</a>
          </li>
        );
      }
    }

    if (currentPage < totalPages) {
      str.push(
        <li key="next" className={`${styles.pageItem} ${styles.next}`}>
          <a onClick={() => setCurrentPage(currentPage + 1)}>
            <img src={nextPagination} alt="nextPagination" />
          </a>
        </li>
      );
    }

    return str;
  };
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Our Blogs", link: "" },
  ];

  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  if (loading) return <p>Loading blogs...</p>;

  return (
    <>
      <MetaComponent
        title="Global Education, Skills & Career Blogs | Aptech Limited"
        desc="Explore expert blogs by Aptech Limited on IT training, digital skills, vocational education, and career development across global industries. Trusted learning leader since 1986. Read More"
        keywords="aptech blog, aptech training solutions, aptech customer care"
      />
      <BreadCrumb menu={breadcrumb} />

      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <div className={`${styles.Blogs} mt-5`}>
          <div className="container">
            <div className="section">
              <div className="row g-0 align-items-center justify-content-between">
                <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center">
                  <p className="heading mb-0 me-3">Our Blogs</p>
                </div>
                <div className={`col-lg-6 col-md-6 col-12 ${styles.searchBox}`}>
                  <div className={`${styles.searchContainer}`}>
                    <div>
                      <FiSearch className={styles.searchIcon} />
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={styles.searchInput}
                      />
                    </div>
                    {searchTerm && (
                      <FiX
                        className={styles.clearIcon}
                        onClick={() => setSearchTerm("")}
                      />
                    )}
                  </div>
                </div>
              </div>

              <>
                <div className={styles.blogsList}>
                  <div className="row">
                    {paginatedData?.map((card, index) => (
                      <div
                        className={classNames("col-lg-4 col-md-6 col-sm-12")}
                        key={index}
                        onClick={() => handleCardClick(card.title)}
                      >
                        <div className={` ${styles.blogsCard}`}>
                          <div className={styles.imageWrapper}>
                            {card.main_img && (
                              <img
                                src={card.main_img}
                                alt={card.imgAlt ?? "blog image"}
                                title={card.imgTitle}
                                className="w-100"
                              />
                            )}
                            <div className={styles.overlay}>
                              <p className={styles.readMoreText}>Read More</p>
                              <Icon name="readMore" />
                            </div>
                          </div>

                          <div className="mt-3">
                            <p className={`para mb-0`}>
                              <span className={styles.bogsSpan}>
                                {formatDate(card.date)}
                              </span>
                            </p>
                            <p className={`para ${styles.blogsHeading}`}>
                              <strong>{card.title}</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={styles.pagination}>
                  <ul
                    className={`${styles.ulContainer} ${styles.paginationList}`}
                  >
                    {createPagination()}
                  </ul>
                </div>
              </>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Blogs;
